import * as React from 'react'
import {IAppStore, IAppUser} from '../../interfaces/reducers'
import {ArchCreator} from './ArchCreator'
import {ArchRegister} from './ArchRegister'
import {ArchHisotory} from './ArchHisotory'
import {Extent, Feature} from '../../core/models'
import appConfig from '../../reducers/appConfig'
import {IFeatureLayerInfos, ISelectedFeature} from '../../core/interfaces/reducers'
import {createNewFeature} from '../../core/helpers'
import {ServiceHub} from '../../core/ServiceHub'
import {connect} from 'react-redux'
import {
  IEditsDispatcher,
  IGeometryEditsDispatcher,
  IPopupDispatcher,
  ISingleViewDispatcher
} from '../../core/interfaces/dispatchers'
import {appSingleViewDispatcher} from '../../dispatchers/appSingleViewDispatcher'
import {appGeometryEditsDispatcher} from '../../dispatchers/appGeometryEditsDispatcher'
import {appEditsDispatcher} from '../../dispatchers/appEditsDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {getMapService} from '../../core/reducers/map'
import {DrawSource} from '../../core/enums/DrawSource'

interface ParentProps {
  mapComponent?: JSX.Element
}

interface OwnProps {
  user?: IAppUser
  infos: IFeatureLayerInfos
  selected?: ISelectedFeature
  mobile: boolean
}

interface DispatchProps extends ISingleViewDispatcher, IGeometryEditsDispatcher, IEditsDispatcher, IPopupDispatcher {}

type Props = DispatchProps & OwnProps & ParentProps

interface State {
  detailSelected: boolean
  historySelected: boolean

  selectedHistoryEntities?: {
    plan: Feature
    history: Feature[]
  }
  refreshPlans?: () => void
  loading: boolean
}

class MainClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      detailSelected: false,
      historySelected: false,
      loading: false
    }
  }
  componentWillUnmount() {
    this.props.removeSelection()
  }

  setNewFeature = () => {
    const newHistoryPlan = createNewFeature(this.props.infos[appConfig.archImport.planHistory.url])
    newHistoryPlan.set('ArchPlanHistoryStatusId', 1)
    this.props.setSelectedFeature(newHistoryPlan, appConfig.archImport.planHistory.url)
  }

  onCreateNew = () => {
    getMapService().drawing.unMark(DrawSource.ExportExtent)
    getMapService().zoomTo([new Extent([3048135, 5230578, 3060135, 5241578])])
    this.setNewFeature()
    this.setState({...this.state, detailSelected: true})
  }

  onChangeStatus = (plan: Feature, status: number) => {
    const newHistoryPlan = createNewFeature(this.props.infos[appConfig.archImport.planHistory.url])
    newHistoryPlan.set('ArchPlanHistoryStatusId', status)
    newHistoryPlan.set('ArchPlanId', plan.get('Id'))
    this.props.setSelectedFeature(newHistoryPlan, appConfig.archImport.planHistory.url)
    this.setState({...this.state, detailSelected: true})
  }
  onSelectedHistory = (plan: Feature) => {
    this.setState({...this.state, loading: true}, () => {
      ServiceHub.gisCrudService
        .execute(this.props.infos[appConfig.archImport.planHistory.url], {
          where: `"ArchPlanId" = ${plan.get('Id')}`,
          orderByFields: [`Created DESC`]
        })
        .then(p => {
          ServiceHub.gisCrudService
            .attachAttachments({layerInfo: this.props.infos[appConfig.archImport.planHistory.url], features: p})
            .then(features => {
              this.setState({
                ...this.state,
                selectedHistoryEntities: {plan: plan, history: features},
                loading: false,
                historySelected: true
              })
            })
        })
    })
  }

  onHistoryFromDetail = (feature: Feature) => {
    this.setState({...this.state, historySelected: true})
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.user && !this.props.user) {
      this.setState({...this.state, detailSelected: false, historySelected: false, selectedHistoryEntities: undefined})
    } else if (!prevProps.user && this.props.user) {
      if (this.state.refreshPlans) {
        this.state.refreshPlans()
      }
    }
  }

  render() {
    return (
      <div className="arch-import" style={{opacity: !this.props.user ? 0 : 1}}>
        <div
          className="arch-panel-container"
          style={{padding: appConfig.isArchImport && !this.props.mobile ? '10px 10%' : '0'}}
        >
          <ArchRegister
            refreshPlansHandle={rp => {
              this.setState({...this.state, refreshPlans: rp})
            }}
            onChangeStatus={this.onChangeStatus}
            onSelectedHistory={this.onSelectedHistory}
            onCreateNew={this.onCreateNew}
            infos={this.props.infos}
            user={this.props.user}
          />
          <ArchCreator
            mobile={this.props.mobile}
            user={this.props.user}
            mapComponent={this.props.mapComponent}
            selected={this.state.detailSelected}
            selectedPlan={this.props.selected}
            geometryEditsDispatcher={this.props}
            layerInfo={this.props.infos[appConfig.archImport.planHistory.url]}
            onBack={() => {
              this.setState({...this.state, detailSelected: false}, () => {
                if (this.state.refreshPlans) {
                  this.state.refreshPlans()
                }
              })
            }}
            onHistory={this.onHistoryFromDetail}
          />
          <ArchHisotory
            popupDispatcher={this.props}
            info={this.props.infos[appConfig.archImport.planHistory.url]}
            planInfo={this.props.infos[appConfig.archImport.plan.url]}
            selected={this.state.historySelected && !!this.state.selectedHistoryEntities}
            historyData={this.state.selectedHistoryEntities}
            onBack={() =>
              this.setState({...this.state, historySelected: false}, () => {
                if (this.state.refreshPlans) {
                  this.state.refreshPlans()
                }
              })
            }
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IAppStore) => ({
  user: state.userInfo.user,
  infos: state.layerInfos.featureLayerInfos,
  selected: state.data.singleViewSelectedFeature,
  queries: state.dataQueries,
  mobile: state.application.mobile
})

export const Main = connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appSingleViewDispatcher,
  ...appGeometryEditsDispatcher,
  ...appEditsDispatcher,
  ...appPopupDispatcher
})(MainClass)
